import { common_urls_cws2 } from 'src/environments/environment';

export const BANK_ACCOUNT_CHANGE_BASE_ROUTE = 'bank-account-change';
// Used as the first segment for every router.navigate(['/bank-account-change', ...]) call in this module.
export const BANK_ACCOUNT_CHANGE_BASE_PATH = `/${BANK_ACCOUNT_CHANGE_BASE_ROUTE}`;

export const BANK_ACCOUNT_CHANGE_SCREEN_TYPE = BANK_ACCOUNT_CHANGE_BASE_ROUTE;

export const BANK_ACCOUNT_CHANGE_ROUTES = {
  DETAILS: 'details',
  POLICY_SELECTION: 'policy-selection',
  CONFIRMATION: 'confirmation',
  SUBMISSION: 'submission',
} as const;

// Japan Post Bank (ゆうちょ銀行) uses a passbook symbol/number format instead of branch/account number.
export const BANK_ACCOUNT_CHANGE_JAPAN_POST_BANK_CODE = '9900';

export const BANK_ACCOUNT_CHANGE_EXTERNAL_URLS = {
  PREMIUM_PAYMENT_FAQ: 'https://manulife.my.site.com/faq/s/article/%E4%BF%9D%E9%99%BA%E6%96%99%E3%81%AE%E3%81%8A%E6%94%AF%E6%89%95%E5%8F%A3%E5%BA%A7%E6%8C%AF%E6%9B%BF-202403261128',
  AVAILABLE_FINANCIAL_INSTITUTIONS: 'https://www.muf.bk.mufg.jp/collect/net/bank/',
} as const;

export enum PolicyType {
  DIGITAL = 'DIGITAL',
  PAPER = 'PAPER',
}

export const BANK_ACCOUNT_CHANGE_POLICY_TYPE = PolicyType;

export const BANK_ACCOUNT_CHANGE_PAPER_POLICY_PA_CODES = ['0001'] as const;

export const BANK_ACCOUNT_CHANGE_PAPER_POLICY_PA_CODE = BANK_ACCOUNT_CHANGE_PAPER_POLICY_PA_CODES[0];

export const BANK_ACCOUNT_CHANGE_DIGITAL_POLICY_PA_CODE = '000000';

export const BANK_ACCOUNT_CHANGE_API_URLS = {
  LOAD_BANK_ACCOUNT_CHANGE: `${common_urls_cws2.bffBaseUrl_mvp3}/load/bank-account-change`,
  LOAD_BANK_ACCOUNT_CHANGE_DIGITAL_NTT_INIT: `${common_urls_cws2.bffBaseUrl_mvp3}/load/bank-account-change-digital-ntt-init`,
  SUBMIT_BANK_ACCOUNT_CHANGE_DIGITAL: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/bank-account-change-digital`,
  SUBMIT_BANK_ACCOUNT_CHANGE_PAPER: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/bank-account-change-paper`,
} as const;

export const BANK_ACCOUNT_CHANGE_NTT_GATEWAY_URL: string = '';

// Status code APIM appends when NTT redirects back to CWS after the customer finishes at the gateway.
export const BANK_ACCOUNT_CHANGE_NTT_RETURN_STATUS = {
  SUCCESS: '2',
  ERROR_CODES: ['3', '4'],
  CANCELLED: '9',
} as const;
